<span class="message">
  @if (getIcon(); as icon) {
    <ui-icon [faName]="icon" faStyle="light"></ui-icon>
  }
  {{ message }}
</span>

@if (action) {
  <span class="action">
  <button (click)="snackBarRef?.dismissWithAction()" mat-button>{{ action }}</button>
</span>
}
